"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("../../classnames"));
var PlainButton_1 = __importDefault(require("../buttons/PlainButton"));
var Icon_1 = __importDefault(require("../Icon"));
var Panel_1 = __importDefault(require("../Panel"));
// This shouldn't be necessary, but is due to
// https://github.com/reactjs/react-modal/issues/497
var ReactModal = require("react-modal");
var entrances = {
    slideIn: "chq-mdl-si",
    zoomIn: "chq-mdl-zi"
};
var widths = {
    narrow: "chq-mdl-wr",
    normal: "chq-mdl-wn"
};
var ModalDialogHeading = function (_a) {
    var children = _a.children, bigCloseIcon = _a.bigCloseIcon, onClose = _a.onClose, props = __rest(_a, ["children", "bigCloseIcon", "onClose"]);
    return (react_1.default.createElement(Panel_1.default.Heading, __assign({ primary: true }, props),
        children,
        react_1.default.createElement(PlainButton_1.default, { "aria-label": "Close", className: "chq-mdl--cl", onClick: onClose },
            react_1.default.createElement(Icon_1.default, { icon: bigCloseIcon ? "close" : "ios-close-empty" }))));
};
var modalStyle = {
    overlay: {
        backgroundColor: "rgba(0, 0, 0, .3)",
        zIndex: 2147483647
    }
};
var ModalDialog = function (_a) {
    var _b = _a.appElement, appElement = _b === void 0 ? document.body : _b, bodyOpenClassName = _a.bodyOpenClassName, children = _a.children, className = _a.className, contentRef = _a.contentRef, _c = _a.entrance, entrance = _c === void 0 ? "slideIn" : _c, ariaLabelledBy = _a.ariaLabelledBy, ariaDescribedby = _a.ariaDescribedby, onClose = _a.onClose, _d = _a.style, style = _d === void 0 ? undefined : _d, _e = _a.width, width = _e === void 0 ? "normal" : _e, _f = _a.registerModal, registerModal = _f === void 0 ? function () { } : _f;
    react_1.useEffect(function () {
        registerModal(true);
        return function () { return registerModal(false); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (react_1.default.createElement(ReactModal, { aria: {
            labelledby: ariaLabelledBy,
            describedby: ariaDescribedby,
            modal: true
        }, appElement: appElement, bodyOpenClassName: bodyOpenClassName || "", className: classnames_1.default("chq-mdl", className, entrances[entrance], widths[width]), contentRef: contentRef, onRequestClose: onClose, isOpen: true, style: style ? __assign(__assign({}, modalStyle), { overlay: __assign(__assign({}, modalStyle.overlay), style.overlay), content: style.content }) : modalStyle }, children));
};
ModalDialog.Heading = ModalDialogHeading;
ModalDialog.Body = Panel_1.default.Body;
ModalDialog.LoaderBody = Panel_1.default.LoaderBody;
ModalDialog.Footer = Panel_1.default.Footer;
exports.default = ModalDialog;
